(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsTemplate', rmsTemplate);

    function rmsTemplate() {
        return {
            restrict: 'E',
            scope: {
                template: '=',
                data: '=?',
                options: '=?',
                refreshContent: '=?',
                actionSave: '=?'
            },
            controller: rmsTemplateCtrl,
            controllerAs: 'vm',
            bindToController: true,
        };
    }

    function rmsTemplateCtrl($scope, $compile, $element, lodash) {
        var vm = this;
        this.$onInit = function() {
            vm.refreshContent = refreshContent;

            callEventChanged();
            initContent();
        }

        function refreshContent() {
            if (typeof vm.refresh === typeof function () {}) {
                vm.refresh(vm.data);
            } else {
                initContent();
            }
            callEventChanged();
        }

        function callEventChanged() {
            if (lodash.has(vm.options, 'event.changed')) {
                $scope.$emit(vm.options.event.changed, vm.data);
            }
        }

        function destroyChildScope() {
            if (vm.childScope !== null && vm.childScope !== undefined) {
                vm.childScope.$destroy();
            }
        }

        function removeElementClone() {
            if (vm.elementClone !== null && vm.elementClone !== undefined) {
                vm.elementClone.remove();
            }
        }

        function initContent() {
            $element.html(vm.template);

            destroyChildScope();
            removeElementClone();

            vm.childScope = $scope.$new();
            vm.elementClone = $compile($element.contents())(vm.childScope);
            $scope.$on('$destroy', () => {
                destroyChildScope();
                removeElementClone();
            });
        }
    }
})();